/* Google Store Widget loader — renders the highest store-badge tier the
   Merchant Center account qualifies for (gold "Top Quality Store" when Store
   Quality = Exceptional). Domain-bound to basicslife.com; NO merchant id.

   Hardened for this store (Cloudflare Rocket Loader is ON):
   - This file is loaded as an EXTERNAL script with data-cfasync="false", which
     Cloudflare reliably excludes from Rocket Loader (inline scripts are NOT
     reliably excluded — that's why start() lives here, not inline).
   - POLLS for window.merchantwidget instead of using merchantwidget.js's
     'load' event (defer / Rocket-Loader ordering can make a load listener miss).
   - Single-start + retry cap so it never double-renders or polls forever. */
/* 2026-10-10 (Speed S2a, Changes to make, his yes): LOAD LATER. merchantwidget.js is no longer
   in theme.liquid. This file adds it only on the shopper's first scroll / tap / key, or 5 s after
   the page has finished loading, whichever comes first, so Google's badge window (≈7 s of
   downloading) no longer competes with the product photo and price. Same badge, same place. */
(function () {
  var started = false, tries = 0, MAX = 80; // ~12s at 150ms
  var asked = false, EVENTS = ['scroll', 'touchstart', 'pointerdown', 'keydown'];
  function load() {
    if (asked) return;
    asked = true;
    for (var i = 0; i < EVENTS.length; i++) window.removeEventListener(EVENTS[i], load, { passive: true });
    var s = document.createElement('script');
    s.id = 'merchantWidgetScript';
    s.src = 'https://www.gstatic.com/shopping/merchant/merchantwidget.js';
    s.async = true;
    s.setAttribute('data-cfasync', 'false');
    (document.head || document.documentElement).appendChild(s);
    setTimeout(go, 150);
  }
  for (var i = 0; i < EVENTS.length; i++) window.addEventListener(EVENTS[i], load, { passive: true });
  function later() { setTimeout(load, 5000); }
  if (document.readyState === 'complete') later(); else window.addEventListener('load', later);
  function go() {
    if (started) return;
    if (window.merchantwidget && typeof window.merchantwidget.start === 'function') {
      started = true;
      try {
        window.merchantwidget.start({
          position: 'RIGHT_BOTTOM',  // stack ABOVE the WhatsApp launcher (#wa-widget-send-button: right 20, bottom 120, 50x50)
          region: 'IN',              // force India locale; avoids geo auto-detect misses
          sideMargin: 20,            // align with WhatsApp's right offset
          bottomMargin: 180,         // sit just above WhatsApp (its top edge ~170px from viewport bottom) + gap
          mobileSideMargin: 20,
          mobileBottomMargin: 180
        });
      } catch (e) { /* no-op */ }
      return;
    }
    if (++tries < MAX) setTimeout(go, 150);
  }
})();

/* ------------------------------------------------------------------------
   Overlay-aware visibility (added 2026-06-17)
   The Top Quality Store badge renders into #google-merchantwidget-iframe-wrapper
   at z-index 2147483647 (max), so it floats ON TOP of every overlay. Hide it
   whenever something is open over the PDP — cart drawer, any PDP modal, the
   Kiwi size chart, or the GoKwik/Breeze checkout — and restore it when they
   close. The badge stays visible during normal PDP browsing.
   (This file is only loaded on product templates, so the badge is already
   scoped to PDPs.) ------------------------------------------------------- */
(function () {
  function overlayOpen() {
    var d = document, de = d.documentElement, b = d.body;
    // Cart drawer (also covers its in-drawer size + notify sub-modals — they live inside it)
    if (de.classList.contains('bl-cartdrawer-lock') || (b && b.classList.contains('bl-cartdrawer-lock'))) return true;
    // PDP modals: size, size-chart, notify, prepaid T&C
    if (d.querySelector('.bpdp-modal.is-open')) return true;
    // Kiwi size-chart modal (backdrop drops its .hide class when open)
    var kb = d.querySelector('.ks-modal-backdrop');
    if (kb && !kb.classList.contains('hide')) return true;
    // GoKwik / Breeze checkout overlay (#breezeCheckout has ~0 height when closed)
    var bc = d.getElementById('breezeCheckout');
    if (bc && bc.getBoundingClientRect().height > 50) return true;
    // 2026-10-10: the size help sheet (Find my size) and the Ask chat panel
    if (de.classList.contains('bl-sfo-lock') || d.querySelector('.bl-sfo.is-open')) return true;
    if (d.querySelector('#bba-wrap.bba-open')) return true;
    return false;
  }
  var lastHidden = null;
  function apply() {
    var w = document.getElementById('google-merchantwidget-iframe-wrapper');
    if (!w) return;
    var hide = overlayOpen();
    if (hide === lastHidden) return; // avoid redundant style writes
    lastHidden = hide;
    w.style.transition = 'opacity .15s ease';
    w.style.opacity = hide ? '0' : '';
    w.style.visibility = hide ? 'hidden' : '';
    w.style.pointerEvents = hide ? 'none' : '';
  }
  // Instant reaction to the most common case (cart drawer toggles a class on <html>/<body>)
  try {
    var mo = new MutationObserver(apply);
    mo.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    if (document.body) mo.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  } catch (e) { /* no-op */ }
  // Backstop for modals / checkout that toggle deeper in the DOM, and for the
  // widget rendering after this runs.
  setInterval(apply, 350);
  window.addEventListener('popstate', apply);
  apply();
})();
